export default __webpack_public_path__ + "static/media/image-austronaut.62003e3e.png";